import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  options: [
    { name: "HDMI", icon: "https://cdn-icons-png.flaticon.com/128/2448/2448812.png" ,custom:false},
    { name: "Projector", icon: "https://cdn-icons-png.flaticon.com/128/3382/3382956.png" ,custom:false},
    { name: "USB C", icon: "https://cdn-icons-png.flaticon.com/128/8519/8519965.png",custom:false },
    { name: "AirPlay", icon: "https://cdn-icons-png.flaticon.com/128/5124/5124697.png",custom:false },
    { name: "Zoom", icon: "https://cdn-icons-png.flaticon.com/128/4401/4401470.png",custom:false },
    { name: "Meet", icon: "https://cdn-icons-png.flaticon.com/128/5968/5968552.png",custom:false },
    { name: "Skype", icon: "https://cdn-icons-png.flaticon.com/128/3536/3536534.png" ,custom:false},
    { name: "WebEx", icon: "https://cdn-icons-png.flaticon.com/128/882/882832.png",custom:false },
    { name: "Teams", icon: "https://cdn-icons-png.flaticon.com/128/906/906349.png",custom:false }
  ],
};

export const optionsSlice = createSlice({
  name: 'options',
  initialState,
  reducers: {
    addOption: (state, action) => {
      
      state.options.push(action.payload);
      state.options = Array.from(new Set(state.options.map(obj => obj.name))).map(name => { return state.options.find(obj => obj.name === name) });
    },
    removeOption: (state, action) => {
      state.options = state.options.filter(option => option !== action.payload);
    },
    clearOptions: state => {
      state.options = [];
    }
  }
});

export const { addOption, removeOption, clearOptions } = optionsSlice.actions;

export default optionsSlice.reducer;
